import React, { Component } from 'react';
import { Marker, InfoWindow } from "react-google-maps";

const MarkerCustom = ({ visible, onClick, icon, location,name, index }) => (
    <Marker key={'keyM' + index} onClick={onClick} icon={icon} position={location} >
        {
            visible &&
            <InfoWindow onCloseClick={onClick}>
                <div>
                    {' '}
                    {name}
                </div>
            </InfoWindow>
        }
    </Marker>
)

export default MarkerCustom;



// WEBPACK FOOTER //
// ./src/Components/Rutas/marker.js